import {Component, CUSTOM_ELEMENTS_SCHEMA, OnInit} from '@angular/core';
import {GlobalLoaderService} from '../../../services/global-loader.service';
import {ApiAgentService} from '../../../services/api-agent.service';
import {FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {EnvironmentService} from '../../../services/environment.service';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {MyBusiness} from '../../../models/my-business';
import {PartnerMerchantRelationship} from '../../../models/partner-merchant-relationship.model';
import {isNotNullOrUndefined} from 'codelyzer/util/isNotNullOrUndefined';
import {firstValueFrom} from 'rxjs';
import {Partner} from '../../../models/partner';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';

declare var Snackbar: any;
declare var $: any;

@Component({
  selector: 'app-settings-update',
  templateUrl: './settings-update.component.html',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, TranslateModule, RouterModule],
  styleUrls: ['./settings-update.component.scss']
})
export class SettingsUpdateComponent implements OnInit {

  private newMerchantImage;
  submitting;
  form: FormGroup;
  affiliateUrlForm: FormGroup;
  submitted;
  myBusiness: MyBusiness;
  lang: any;
  loading: any;
  myMobileNumber: any;
  storeUsernameValidating: string;
  partnerConnectionsRequest: PartnerMerchantRelationship[];
  myPartners: Partner[];

  isAccountant: boolean;
  isManager: boolean;
  isSales: boolean;
  isMerchant: boolean;

  checkPermission() {
    let perms = this.env.checkPermission(this.myBusiness.subAccountType, this.myBusiness.subAccountGovId);
    this.isAccountant = perms.isAccountant;
    this.isSales = perms.isSales;
    this.isManager = perms.isManager;
    this.isMerchant = perms.isMerchant;
  }

  constructor(private loader: GlobalLoaderService,
              private formBuilder: FormBuilder,
              private translate: TranslateService,
              private env: EnvironmentService,
              private api: ApiAgentService) {
  }

  async ngOnInit() {
    this.affiliateUrlForm = this.formBuilder.group({
      affiliateUrl: ['']
    });

    this.form = this.formBuilder.group({
      shopName: ['', [Validators.required]],
      vat: ['', [Validators.pattern(/^[0-9]/)]],
      firstName: ['', [Validators.required]],
      lastName: ['', [Validators.required]],
      email: ['', [Validators.email, Validators.required]],
      mobile: ['', [Validators.minLength(10), Validators.maxLength(10)]],
      licenseName: ['', [Validators.required]],
      licenseType: ['', [Validators.required]],
      licenseNumber: ['', [Validators.required]],
      storeUsername: [null],
      storeUrl: [null],
      logoUrl: [''],
      apiId: [null],
      apiKey: [null],
      shopifyShopDomain: [null],
      iban: [null],
      ibanBank: [null]
    });


    this.form.controls['email'].disable();
    this.form.controls['mobile'].disable();
    this.form.controls['licenseName'].disable();
    this.form.controls['licenseType'].disable();
    this.form.controls['licenseNumber'].disable();

    this.form.controls['apiKey'].disable();
    this.form.controls['apiId'].disable();

    this.form.controls['iban'].disable();
    this.form.controls['ibanBank'].disable();

    this.loading = true;

    // get my business
    this.myBusiness = await this.api.getMyBusiness(false);

    // check for shopify
    console.log('my business', this.myBusiness);

    // load partner
    if (this.myBusiness.subAccountGovId == null) {
      this.api.getMyPartners().then(value => {
        this.myPartners = value;
      });
    }

    // get api settings
    this.checkPermission();

    this.myMobileNumber = this.myBusiness.mobileNumber;
    this.affiliateUrlForm.patchValue({
      affiliateUrl: this.myBusiness.affiliateUrl
    });

    console.log('my business', this.myBusiness);

    this.form.patchValue({
      shopName: this.myBusiness.businessName,
      vat: this.myBusiness.vat,
      firstName: this.myBusiness.firstName,
      lastName: this.myBusiness.lastName,
      email: this.myBusiness.email,
      mobile: this.myBusiness.mobileNumber,
      licenseName: this.myBusiness.licenseName,
      licenseType: this.myBusiness.licenseType == 'cr' ? await firstValueFrom(this.translate.get('Commercial Registration')) : await firstValueFrom(this.translate.get('Freelancer Certificate')),
      licenseNumber: this.myBusiness.licenseNumber,
      logoUrl: this.myBusiness.logoUrl,
      iban: this.myBusiness.iban != undefined && this.myBusiness.iban != '' && this.myBusiness.iban != null ? this.myBusiness.iban : null,
      storeUsername: this.myBusiness.storeUsername,
      storeUrl: this.myBusiness.storeUsername == null ? '' : this.env.getStoreUrl() + this.myBusiness.storeUsername,
    });

    this.storeUsernameValidating = this.myBusiness.storeUsername ? 'valid' : null;

    // fill webhooks form data - starting by payment
    setTimeout(async () => {
      await this.loadResources();
      await this.loadMerchantImage();

      this.loading = false;
      this.lang = await firstValueFrom(this.translate.get('lang'));

    }, 1000);
  }

  private timer: any;

  async storeUsernameChanged() {
    if (this.timer) {
      clearTimeout(this.timer);
    }
    let storeUsername: string = this.form.value['storeUsername'];

    if (storeUsername) {
      this.storeUsernameValidating = 'pending';
      let usernameRegex = /^[a-zA-Z0-9]+$/;
      if (storeUsername.match(usernameRegex)) {
        this.timer = setTimeout(async () => {
          try {
            let storeUsername: string = this.form.value['storeUsername'];
            this.form.patchValue({
              storeUrl: storeUsername == null ? '' : this.env.getStoreUrl() + storeUsername
            });
            let result = await this.api.validateStoreUsername(storeUsername);
            this.storeUsernameValidating = result ? 'valid' : 'invalid';
          } catch (e) {
            this.storeUsernameValidating = 'invalid';
          }
        }, 3000);
      } else {
        this.storeUsernameValidating = 'invalid';
      }
    } else {
      this.storeUsernameValidating = null;
    }

  }

  async submitForm() {
    this.submitted = true;
    if (this.form.valid && this.storeUsernameValidating != 'invalid') {
      this.submitting = true;
      // if image is changed
      if (this.newMerchantImage) {
        try {
          let newMyBusiness = await this.api.postMyBusinessImage(this.newMerchantImage);
          this.form.patchValue({
            logoUrl: newMyBusiness.logoUrl
          });
        } catch (e) {
          console.log('Handle Merchant Image Error', e);
          SettingsUpdateComponent.showToast(await firstValueFrom(this.translate.get('Could not upload merchant image. Try again')));
          await this.loadMerchantImage();
          this.submitting = false;
          this.submitted = false;
          return false;
        }
      }

      try {
        // let result = await this.api.postMyBusinessData(
        await this.api.postMyBusinessData(
          this.form.value['shopName'],
          this.form.value['firstName'],
          this.form.value['lastName'],
          this.form.value['vat'],
          this.form.value['logoUrl'],
          this.form.value['storeUsername']
        );
        this.myBusiness = await this.api.getMyBusiness(true);
        SettingsUpdateComponent.showToast(await firstValueFrom(this.translate.get('My settings saved successfully')));
      } catch (e) {
        if (e.error.title) {
          SettingsUpdateComponent.showToast(await firstValueFrom(this.translate.get(e.error.title)));
        } else {
          SettingsUpdateComponent.showToast(await firstValueFrom(this.translate.get('Could not save my setting. Try again')));
        }
      } finally {
        this.submitting = false;
        this.submitted = false;
      }
    }
  }

  private async loadMerchantImage() {
    try {
      let image = await this.api.getMyBusinessImage();
      if (isNotNullOrUndefined(image)) {
        let merchantImage: any = await this.readFile(image);
        merchantImage = merchantImage.replace('application/json;', 'image/png;');
        SettingsUpdateComponent.resetDropifyPreview(merchantImage);
      }
    } catch (ex) {
      console.log(ex);
    }
  }

  private readFile(file) {
    return new Promise(((resolve, reject) => {
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onloadend = () => {
        resolve(reader.result);
      };
      reader.onerror = () => {
        reject(reader.error);
      };
    }));
  }

  private static showToast(msg) {
    Snackbar.show({
      text: msg,
      pos: 'bottom-center'
    });
  }

  async handleMerchantImageInput(files) {
    if ((this.myBusiness.subAccountType != null && this.myBusiness.subAccountType.includes('Manager')) || this.myBusiness.subAccountGovId == null) {
      if (files.length > 0) {
        let file = files[0];
        this.newMerchantImage = await this.readFile(file);
      }
    } else {
      SettingsUpdateComponent.showToast('Not allowed');
    }
  }

  private static resetDropifyPreview(src, fname = '') {
    let input = $('.dropify');
    let wrapper = input.closest('.dropify-wrapper');
    let preview = wrapper.find('.dropify-preview');
    let filename = wrapper.find('.dropify-filename-inner');
    let render = wrapper.find('.dropify-render').html('');

    input.val('').attr('title', fname);
    wrapper.removeClass('has-error').addClass('has-preview');
    filename.html(fname);
    render.append($('<img alt="" src=""/>').attr('src', src).css('max-height', input.data('height') || ''));
    preview.fadeIn();
  }

  // noinspection DuplicatedCode
  private async loadResources() {
    await this.loader.loadExternalStyles('/plugins/notification/snackbar/snackbar.min.css');
    await this.loader.loadExternalScript('/plugins/notification/snackbar/snackbar.min.js');
    await this.loader.loadExternalStyles('/plugins/dropify/dropify.min.css');
    await this.loader.loadExternalStyles('/assets/css/users/account-setting.css');
    await this.loader.loadExternalScript('/plugins/dropify/dropify.min.js');
    await this.loader.loadExternalScript('/plugins/blockui/jquery.blockUI.min.js');
    await this.loader.loadExternalScript('/assets/js/users/account-settings.js');
    await this.loader.loadExternalScript('/plugins/table/datatable/datatables.js');
    await this.loader.loadExternalStyles('/plugins/table/datatable/datatables.css');

    $('.dropify').dropify({
      messages: {
        'default': await firstValueFrom(this.translate.get('Click to Upload or Drag n Drop')),
        'remove': '<i class="flaticon-close-fill"></i>',
        'replace': await firstValueFrom(this.translate.get('Upload or Drag n Drop'))
      }
    });
  }

}
